import { render, staticRenderFns } from "./template-dialog.vue?vue&type=template&id=27cfc7e4"
import script from "./template-dialog.vue?vue&type=script&lang=js"
export * from "./template-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports